'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Admin').service('ReportsCommonService', ['CommonService', 'CommonPostService', function (CommonService, CommonPostService) {

	//################### CONCATINATION BLOCK-STARTS #############################
	//*******PURPOSE: THIS METHOD IS USED TO GET DYNAMIC QUERY DATA TO AUTO POPULATE
	///*******CREATED BY: DHANUSH.B
	///*******CREATED DATE: 02-03-2020
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.GetDynamicQueryDetailsDataToAutoPopulationfortheReport = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.LoggedFacilityID = EMRPracticeModel.LoggedFacilityID;
		let dataToService = {
			DynamicQueryExecutionReportID: _.get(postData, 'DynamicQueryReportDetails.DynamicQueryExecutionReportID')
		};
		var timeOut = 180 * 1000;//Placing 3 mints Time Out
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Reports_DynamicReports() + "GetDynamicReportingDBConnectionDetails", dataToService).then(function (serviceResponse) {
			if (!serviceResponse || isError(serviceResponse)) return;
			if (serviceResponse.IsFromDataWareHouseDB) {
				postData.DynamicQueryReportDetails.IsFromDataWareHouseDB = true;
				return CommonPostService.httpPostDataForDataWareHouse('POST', `${CommonService.EHR_Reports_DynamicReports()}GetDynamicQueryDetailsDataToAutoPopulation`, postData, timeOut, undefined, true);
			} 
			return CommonService.PostData('POST', CommonService.EHR_Reports_DynamicReports() + "GetDynamicQueryDetailsDataToAutoPopulation", postData, timeOut, undefined, true).then(
				function (result) {
					return result;
			});
		});
	};

	//###################    GET AUTO GENERATED REPORTS INFORMATION COUNT FOR LOGGED USER  - COUNT    BLOCK START #########################
	//*******PURPOSE: THIS METHOD IS  USED TO  GET AUTO GENERATED BINARY FORMAT  INFORMATION- LIST   
	//*******DEVELOPED BY :RAVI TEJA.P
	//*******CREATED DATE:9/1/2016
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
	this.htmlTemplategetAutoGeneratedReportsCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		//postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		//   return CommonService.PostData('POST', CommonService.EMRClinicalManagement_HTMLTemplates() + "getAutoGeneratedReportsCount", postData).then(
		return CommonService.PostData('POST', CommonService.EMRClinicalManagement_Reports_EHRReports() + "getAutoGeneratedReportsCount", postData).then(
			function (result) {
				return result;
			});

	};
	//###################  GET SAVED REPORT SCHEDULE INFORMATION BLOCK END #########################
}]);